import { Team } from '../types';

// totalProjectCount returns the total number of projects and release groups in the team passed in.
// We refer to this as the number of "projects" in a few places in the app even though this includes release groups.
export const totalProjectCount = ({ teamProjects, teamProjectsCount, teamReleaseGroups, teamReleaseGroupsCount }: Team) =>
  (teamProjects?.length ?? teamProjectsCount ?? 0) + (teamReleaseGroups?.length ?? teamReleaseGroupsCount ?? 0);
